// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class MerchantsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicMerchants';
        this.Server = this.props.context.getState().server.publicMerchants;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'email', 'phone'];

        const defaultHead = [
            { id: 'name', required: true, label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
            { id: 'email', required: true, format: 'email', label: 'email', alignRight: false, cell: 'Text', displayGrid: true },
            { id: 'phone', label: 'phone', alignRight: false, cell: 'Phone', displayGrid: true },
            {
                id: 'countryId',
                label: 'country',
                alignRight: false,
                cell: 'Select',
                from: 'publicCountries',
                object: 'country',
                show: 'name',
                displayGrid: true
            },
            { id: 'isArchived', label: 'isArchived', alignRight: false, cell: 'Boolean', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
